export default function Modal({ open, onClose, title, children, testid }) {
  if (!open) return null;
  return (
    <div className="fixed inset-0 z-50 flex items-end sm:items-center justify-center bg-black/60 p-0 sm:p-4"
         onClick={onClose} data-testid={testid}>
      <div className="bg-white w-full sm:max-w-lg rounded-t-2xl sm:rounded-2xl border border-[#E6DFD1] max-h-[90vh] overflow-y-auto"
           onClick={(e) => e.stopPropagation()}>
        <div className="flex items-center justify-between px-5 py-4 border-b border-[#E6DFD1] sticky top-0 bg-white rounded-t-2xl">
          <h2 className="font-serif font-semibold text-xl text-[#221F1A]">{title}</h2>
          <button onClick={onClose} data-testid={testid ? `${testid}-close` : undefined}
                  className="w-11 h-11 flex items-center justify-center rounded-lg hover:bg-stone-100 text-2xl leading-none text-stone-500">
            ×
          </button>
        </div>
        <div className="p-5">{children}</div>
      </div>
    </div>
  );
}
